'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.configConsumerProps = exports.ConfigConsumer = exports.ConfigContext = undefined;
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
var _react = require('react');
var React = _interopRequireWildcard(_react);
var _localeProvider = require('../locale-provider');
var _localeProvider2 = _interopRequireDefault(_localeProvider);
var _LocaleReceiver = require('../locale-provider/LocaleReceiver');
var _LocaleReceiver2 = _interopRequireDefault(_LocaleReceiver);
var _context = require('./context');
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj['default'] = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

// TODO: remove this lint
// SFC has specified a displayName, but not worked.
/* eslint-disable react/display-name */
exports.ConfigContext = _context.ConfigContext;
exports.ConfigConsumer = _context.ConfigConsumer;
var configConsumerProps = exports.configConsumerProps = ['exported', 'pagenation', 'locale'];
// @ts-ignore
var ConfigProvider = function ConfigProvider(props) {
  var renderProvider = function renderProvider(context, legacyLocale) {
    var children = props.children,
      exported = props.exported,
      pagenation = props.pagenation,
      locale = props.locale,
      modalMovable = props.modalMovable,
      modalAutoCenter = props.modalAutoCenter;
    var config = (0, _extends3['default'])({
      locale: locale || legacyLocale
    }, context);
    if (exported) {
      config.exported = exported;
    }
    if (pagenation) {
      config.pagenation = pagenation;
    }
    if (modalMovable) {
      config.modalMovable = modalMovable;
    }
    if (modalAutoCenter) {
      config.modalAutoCenter = modalAutoCenter;
    }
    return React.createElement(_context.ConfigContext.Provider, {
      value: config
    }, React.createElement(_localeProvider2['default'], {
      locale: locale || legacyLocale,
      _ANT_MARK__: _localeProvider.ANT_MARK
    }, children));
  };
  var renderLovalProvider = function renderLovalProvider() {
    return function (_, __, legacyLocale) {
      return React.createElement(_context.ConfigConsumer, null, function (context) {
        return renderProvider(context, legacyLocale);
      });
    };
  };
  return (
    // @ts-ignore
    React.createElement(_LocaleReceiver2['default'], null, renderLovalProvider())
  );
};
exports['default'] = ConfigProvider;